import React from 'react';
import SPASectionHeading from '../shared/SPASectionHeading';
import MostRejectedTeachers from './MostRejectedTeachers';
import TeacherSearch from './TeacherSearch';
import useSyncOverview from './useSyncOverview';

// The landing page, because every case starts from a teacher.
const TeachersTab = () => {
  const { data, error, isFetching } = useSyncOverview('7d');
  const teachers = data?.teachers ?? [];

  return (
    <>
      <TeacherSearch />

      <SPASectionHeading title="Most rejected posts, last 7 days" />
      {error != null && <p className="tw-m-0 tw-text-sm tw-text-spa-error">Couldn&apos;t load these.</p>}
      {isFetching && teachers.length === 0 && (
        <p className="tw-m-0 tw-text-sm tw-text-spa-secondary">Loading…</p>
      )}
      {!isFetching && error == null && teachers.length === 0 && (
        <p className="tw-m-0 tw-text-sm tw-text-spa-secondary">No rejected posts in the last 7 days.</p>
      )}
      {teachers.length > 0 && <MostRejectedTeachers teachers={teachers} />}
    </>
  );
};

export default TeachersTab;
